import { render, staticRenderFns } from "./CLinkTextBlock.vue?vue&type=template&id=7c665d4a&scoped=true&"
import script from "./CLinkTextBlock.vue?vue&type=script&lang=ts&"
export * from "./CLinkTextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CLinkTextBlock.vue?vue&type=style&index=0&id=7c665d4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c665d4a",
  null
  
)

export default component.exports